import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.bom_config_version_ */
export type BomConfigVersionId = string & { __brand: 'BomConfigVersionId' }

/** Represents the table public.bom_config_version_ */
export default interface BomConfigVersionTable {
  /** Database type: pg_catalog.uuid */
  id: ColumnType<
    BomConfigVersionId,
    BomConfigVersionId | undefined,
    BomConfigVersionId
  >

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  createdBy: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  updatedAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  updatedBy: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  deletedAt: ColumnType<Date | null, Date | string | null, Date | string | null>

  /** Database type: pg_catalog.uuid */
  deletedBy: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.text */
  name: ColumnType<string, string, string>

  /** Database type: pg_catalog.timestamptz */
  dateEffective: ColumnType<Date, Date | string | undefined, Date | string>

  /** Database type: pg_catalog.text */
  notes: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.bool */
  isActive: ColumnType<boolean | null, boolean | null, boolean | null>
}

export type BomConfigVersion = Selectable<BomConfigVersionTable>

export type BomConfigVersionInitializer = Insertable<BomConfigVersionTable>

export type BomConfigVersionMutator = Updateable<BomConfigVersionTable>

export const bomConfigVersionId =
  z.string() as unknown as z.Schema<BomConfigVersionId>

export const bomConfigVersion = z.object({
  id: bomConfigVersionId,
  createdAt: z.coerce.date().nullable().optional(),
  createdBy: z.string().nullable().optional(),
  updatedAt: z.coerce.date().nullable().optional(),
  updatedBy: z.string().nullable().optional(),
  deletedAt: z.coerce.date().nullable().optional(),
  deletedBy: z.string().nullable().optional(),
  name: z.string(),
  dateEffective: z.coerce.date(),
  notes: z.string().nullable().optional(),
  isActive: z.boolean().nullable().optional(),
}) as unknown as z.Schema<BomConfigVersion>

export const bomConfigVersionInitializer = z.object({
  id: bomConfigVersionId.optional(),
  createdAt: z.coerce.date().optional().nullable(),
  createdBy: z.string().optional().nullable(),
  updatedAt: z.coerce.date().optional().nullable(),
  updatedBy: z.string().optional().nullable(),
  deletedAt: z.coerce.date().optional().nullable(),
  deletedBy: z.string().optional().nullable(),
  name: z.string(),
  dateEffective: z.coerce.date().optional(),
  notes: z.string().optional().nullable(),
  isActive: z.boolean().optional().nullable(),
}) as unknown as z.Schema<BomConfigVersionInitializer>

export const bomConfigVersionMutator = z.object({
  id: bomConfigVersionId.optional(),
  createdAt: z.coerce.date().optional().nullable(),
  createdBy: z.string().optional().nullable(),
  updatedAt: z.coerce.date().optional().nullable(),
  updatedBy: z.string().optional().nullable(),
  deletedAt: z.coerce.date().optional().nullable(),
  deletedBy: z.string().optional().nullable(),
  name: z.string().optional(),
  dateEffective: z.coerce.date().optional(),
  notes: z.string().optional().nullable(),
  isActive: z.boolean().optional().nullable(),
}) as unknown as z.Schema<BomConfigVersionMutator>
